import { gql, TypedDocumentNode } from '@apollo/client';
import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useSkippableQuery } from '../../hooks/useSkippableQuery';
import {
  Gender,
  RedirectExpiredTrunkshowQuery,
  RedirectExpiredTrunkshowQueryVariables
} from '../../generated/types';
import { throwQueryError } from '../../lib/apollo/throwQueryError';
import { hrefFor } from '../../routers';
import { Loading } from '../../components/Loading';

export const REDIRECT_EXPIRED_TRUNKSHOW_QUERY: TypedDocumentNode<
  RedirectExpiredTrunkshowQuery,
  RedirectExpiredTrunkshowQueryVariables
> = gql`
  query RedirectExpiredTrunkshowQuery($vertical: Gender, $designerSlug: String) {
    trunkshows(input: { gender: $vertical, designer_slugs: [$designerSlug] }) {
      trunkshows {
        edges {
          node {
            id
            slug
          }
        }
      }
    }
  }
`;

interface Props {
  designerSlug?: string | null;
}

export const RedirectExpiredTrunkshow: React.FC<Props> = ({ designerSlug }) => {
  const { vertical = 'women' } = useParams<{ vertical?: string }>();

  const { data, loading, error } = useSkippableQuery(REDIRECT_EXPIRED_TRUNKSHOW_QUERY, {
    variables: {
      vertical: vertical as Gender,
      designerSlug
    },
    skip: !designerSlug
  });

  if (!designerSlug) return <Redirect to={hrefFor.TrunkshowIndexPage({ vertical: 'women' })} />;

  if (error) throwQueryError(error);
  if (loading || !data) return <Loading />;

  const slug = data.trunkshows?.trunkshows?.edges?.[0]?.node?.slug;

  // if there is an active trunkshow for this designer, redirect to that
  if (slug) return <Redirect to={hrefFor.TrunkshowPage({ vertical, trunkshowSlug: slug })} />;

  // otherwise redirect to the designer page
  return <Redirect to={hrefFor.DesignerPage({ vertical, designerSlug })} />;
};
